export const checkRrnr = (
  rrnr: string,
  setFormData: (x: any) => void,
  formData: any
) => {
  const rrnrDigits = removeNonNumeric(rrnr);

  if (isTooShort(rrnrDigits)) {
    return;
  }
  if (validateRrnr(rrnrDigits)) {
    clearRrnrError();

    setFormData({
      ...formData,
      registerNumber: formatRrnr(rrnrDigits),
      dateOfBirth: getBirthDateFromRrnr(rrnrDigits),
    });
  } else {
    setRrnrError();
  }
};

// helper functions
const clearRrnrError = () => {
  const rrnrEl: HTMLInputElement | null = document.querySelector(
    "input[type=text]#registerNumber"
  );
  rrnrEl?.setCustomValidity("");
};

const setRrnrError = () => {
  const rrnrEl: HTMLInputElement | null = document.querySelector(
    "input[type=text]#registerNumber"
  );
  rrnrEl?.setCustomValidity("Ongeldig rijksregisternummer");
  rrnrEl?.reportValidity();
};
export const validateRrnr = (rrnr: string): boolean => {
  let calc = parseInt(rrnr.slice(0, 9));
  const checkSum = parseInt(rrnr.slice(9, 11));

  let expectedCheckSum = 97 - (calc % 97);
  if (expectedCheckSum === checkSum) {
    return true;
  }
  // do the logic for after 2000
  calc = parseInt("2" + rrnr.slice(0, 9));
  expectedCheckSum = 97 - (calc % 97);

  if (checkSum === expectedCheckSum) {
    return true;
  }
  return false;
};

export const isAfter2000 = (rrnr: string): boolean => {
  let calc = parseInt(rrnr.slice(0, 9));
  const checkSum = parseInt(rrnr.slice(9, 11));

  let expectedCheckSum = 97 - (calc % 97);
  if (expectedCheckSum === checkSum) {
    return false;
  }
  return true;
};

export const formatRrnr = (rrnr: string): string => {
  // length is 11
  return (
    rrnr.slice(0, 2) +
    "." +
    rrnr.slice(2, 4) +
    "." +
    rrnr.slice(4, 6) +
    "-" +
    rrnr.slice(6, 9) +
    "." +
    rrnr.slice(9, 11)
  );
};

export const getBirthDateFromRrnr = (rrnr: string): string => {
  if (rrnr.slice(2, 4) == "00" || rrnr.slice(4, 6) == "00") return "";
  const prefix = isAfter2000(rrnr) ? "20" : "19";
  return `${prefix}${rrnr.slice(0, 2)}-${rrnr.slice(2, 4)}-${rrnr.slice(4, 6)}`;
};

export const removeNonNumeric = (rrnr: string): string => {
  return rrnr.replace(/\D/g, "");
};

export const isTooShort = (rrnr: string): boolean => {
  return rrnr.length < 11;
};
